var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#e60082"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 22,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#fff"
  }, "W")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWero);
export default __webpack_public_path__ + "static/media/wero.e27188bed92cb7f2b5828469d0827220.svg";
export { ForwardRef as ReactComponent };